<script lang="ts">
	// Ported from the TemplateSelect component in Pro Web. Templates are identified by id here, since Enterprise template names aren't unique.
	import type { i18n } from 'types/common'

	import Button from '@isoftdata/svelte-button'
	import Select from '@isoftdata/svelte-select'
	import { getContext } from 'svelte'
	import { getEventValue } from '@isoftdata/browser-event'

	interface Props {
		templates: Array<{ id: number; name: string | null; default: boolean }>
		selectedTemplateId: number | null
		isLoading?: boolean
		/** If provided, shows a button that links here */
		configureTemplatesPath?: string
		onchange: (templateId: number | null) => void
	}

	let { templates, selectedTemplateId, isLoading = false, configureTemplatesPath, onchange }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

{#if templates.length > 0}
	<Select
		{isLoading}
		label={translate('common:template', 'Template')}
		value={selectedTemplateId?.toString() ?? ''}
		append={configureTemplatesPath ? append : undefined}
		onchange={e => onchange(parseInt(getEventValue(e), 10) || null)}
	>
		{#each templates as template (template.id)}
			<option value={template.id.toString()}
				>{template.name || `#${template.id}`}{#if template.default}&nbsp;({translate(
						'common:default',
						'Default',
					)}){/if}</option
			>
		{/each}
	</Select>
{/if}

{#snippet append()}
	{#if configureTemplatesPath}
		<Button
			outline
			color="primary"
			icon="cog"
			href={configureTemplatesPath}
			title={translate('common:configureTemplates', 'Configure Templates')}
		/>
	{/if}
{/snippet}
